// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tab-container {
  display: flex;
  width: 100%;
  padding-inline: 16px;
}

.tab-button {
  flex: 1;
  padding: 12px 0;
  text-align: center;
  color: var(--ion-color-medium);
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.3s ease, color 0.3s ease;
  border-bottom: 3px solid transparent;
  border-radius: 16px 16px 0 0;
  background-color: var(--ion-color-light);
}
.tab-button + .tab-button {
  margin-left: 32px;
}

.tab-button:hover {
  background-color: var(--ion-color-light-shade);
}

.tab-button.active {
  color: var(--label-color, var(--ion-color-primary));
  font-weight: 600;
  border-bottom: 3px solid var(--ion-color-primary);
  background-color: var(--ion-color-primary-tint);
}

:host ion-toolbar {
  padding-left: var(--ion-safe-area-left);
  padding-right: var(--ion-safe-area-right);
}

ion-header ion-toolbar {
  --padding-start: 0;
  --padding-end: 0;
  --padding-bottom: 0;
}

ion-header ion-title {
  display: block;
  margin-bottom: 10px;
  padding-inline: 16px;
}

.subtitle {
  display: block;
  margin: -6px 0 10px;
  padding-inline: 16px;
}

ion-header ion-toolbar.filters-toolbar {
  --ion-safe-area-top: 0px;
  --padding-top: 10px;
  --padding-start: 16px;
  --padding-end: 16px;
  --padding-bottom: 10px;
}

.filter-bar {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-items: flex-end;
  gap: 16px;
  padding-block: 10px;
}
.filter-bar ion-button {
  height: 40px;
  margin: 0;
}
.filter-bar ion-button[fill=outline]::part(native) {
  color: var(--color);
  border-color: var(--border-color);
}
.filter-bar ion-button[fill=outline].ion-activated::part(native) {
  background: var(--background);
}
.filter-bar ion-button[fill=outline] ion-icon {
  color: var(--ion-color-primary);
}

.filter-actions {
  display: flex;
  flex: none;
  gap: 16px;
}

@media (max-width: 767.98px), (orientation: landscape) and (max-height: 500px) {
  .filter-actions {
    flex-basis: 100%;
    justify-content: flex-end;
  }
}
@media (orientation: landscape) and (max-height: 500px) {
  ion-header ion-title {
    margin-bottom: 4px;
  }
  .tab-button {
    padding: 6px 0;
  }
}
.filter-field {
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.filter-field ion-searchbar {
  padding: 0;
}

.filter-field,
.filter-bar > ion-input,
.filter-bar > ion-select {
  flex: 1 1 200px;
  min-width: 0;
}

.filter-field__label {
  overflow: hidden;
  color: var(--ui-text-muted, var(--ion-color-medium, #6b7280));
  font-size: 13px;
  font-weight: 600;
  letter-spacing: 0.02em;
  line-height: 14px;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin-bottom: 2px;
}

.table-loader {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  min-height: 200px;
  padding: 0 24px;
  text-align: center;
}

.table-loader__logo {
  display: block;
  width: 220px;
  max-width: 100%;
  height: 120px;
  margin-bottom: 30px;
  object-fit: contain;
}

.table-loader__message {
  margin: 15px 0 0;
  color: var(--ui-text-muted, var(--ion-color-medium, #6b7280));
  font-size: 13px;
  font-weight: normal;
  letter-spacing: 0.02em;
}

.table-loader__progress {
  position: relative;
  overflow: hidden;
  width: 148px;
  height: 3px;
  border-radius: var(--ui-radius-pill, 999px);
  background: var(--ui-border, rgba(15, 23, 42, 0.1));
}
.table-loader__progress::after {
  position: absolute;
  top: 0;
  left: 0;
  content: "";
  width: 45%;
  height: 100%;
  border-radius: inherit;
  background: linear-gradient(90deg, rgba(var(--ion-color-primary-rgb, 0, 84, 233), 0) 0%, rgba(var(--ion-color-primary-rgb, 0, 84, 233), 0.85) 38%, var(--ion-color-primary, #0054e9) 62%, rgba(var(--ion-color-primary-rgb, 0, 84, 233), 0) 100%);
  box-shadow: 0 0 10px rgba(var(--ion-color-primary-rgb, 0, 84, 233), 0.45);
  animation: table-loader-sweep 1450ms cubic-bezier(0.62, 0, 0.38, 1) infinite;
}

@keyframes table-loader-sweep {
  from {
    transform: translate3d(-110%, 0, 0);
  }
  to {
    transform: translate3d(330%, 0, 0);
  }
}
@media (prefers-reduced-motion: reduce) {
  .table-loader__progress::after {
    animation: none;
    width: 100%;
    background: rgba(var(--ion-color-primary-rgb, 0, 84, 233), 0.45);
    box-shadow: none;
  }
}
nav.pager {
  padding: 0 calc(var(--ion-safe-area-right) + 16px) 0 calc(var(--ion-safe-area-left) + 16px);
  background: var(--ion-background-color, #ffffff);
}

ion-footer ion-text.selected-count {
  padding-left: 16px;
  color: var(--ion-color-medium-shade);
  padding-right: 1.1em;
  border-right: 1px solid var(--ion-color-light-shade);
}

ion-footer ion-toolbar.selection-toolbar {
  --min-height: 44px;
  --border-width: 0 0 1px;
  --border-color: var(--ion-color-light-shade);
}

ion-content:has(> .compact-table)::part(scroll) {
  scrollbar-gutter: stable;
}

.compact-table {
  margin: 8px calc(var(--ion-safe-area-right) + 16px - 10px) 8px calc(var(--ion-safe-area-left) + 16px);
  overflow: hidden;
}
:host-context(.plt-ios) .compact-table {
  margin-right: calc(var(--ion-safe-area-right) + 16px);
}
.compact-table {
  border: 1px solid var(--ion-color-light-shade);
  border-radius: 10px;
}

.compact-table__header,
.compact-table__row {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 12px 16px;
}

.compact-table__header {
  min-height: 50px;
  background-color: var(--ion-color-light);
  border-bottom: 1px solid var(--ion-color-light-shade);
  color: black;
  font-size: 14px;
  font-weight: bold;
}

.compact-table__row {
  min-height: 50px;
  cursor: pointer;
}
.compact-table__row + .compact-table__row {
  border-top: 1px solid var(--ion-color-light-shade);
}
.compact-table__row.selected {
  background-color: var(--search-address-selected-background);
}
.compact-table__row ion-checkbox.row-checkbox {
  flex: none;
  pointer-events: none;
}
.compact-table__row ion-select {
  flex: none;
  max-width: 45%;
}

.compact-table__text {
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
}

.compact-table__title {
  color: var(--ion-color-dark);
  font-size: 14px;
  overflow-wrap: anywhere;
}

.compact-table__subtitle {
  color: var(--ion-color-medium);
  font-size: 12px;
  overflow-wrap: anywhere;
}

:host {
  --search-address-selected-background: var(
    --selected-background,
    rgba(var(--ion-color-primary-rgb), 0.12)
  );
}

ngx-datatable {
  border-radius: 10px;
  margin-inline: 16px;
  border: 1px solid var(--ion-color-light-shade);
  background: #fff;
}
ngx-datatable.material ::ng-deep .datatable-header {
  border-bottom: 1px solid var(--ion-color-light-shade);
}
ngx-datatable.material ::ng-deep .datatable-header .datatable-header-cell {
  padding: 0.9rem 1.2rem;
  background-color: var(--ion-color-light);
  color: black;
  font-size: 14px;
  font-weight: bold;
  text-align: left !important;
  vertical-align: bottom !important;
  white-space: nowrap !important;
}
ngx-datatable.material ::ng-deep .datatable-body .datatable-body-row .datatable-body-cell {
  padding: 0.9rem 1.2rem;
  color: rgba(0, 0, 0, 0.87);
  font-size: 14px;
  font-weight: 400;
  text-align: left;
  vertical-align: top;
}
ngx-datatable.material ::ng-deep .datatable-body-row:not(.active):hover {
  background-color: #eee;
  transition: background 0.3s linear;
}
ngx-datatable.ngx-datatable.material ::ng-deep .datatable-body-row.active.online, ngx-datatable.ngx-datatable.material ::ng-deep .datatable-body-row.active.online:hover, ngx-datatable.ngx-datatable.material ::ng-deep .datatable-body-row.active.online:focus {
  background-color: var(--search-address-selected-background) !important;
}
ngx-datatable.ngx-datatable.material ::ng-deep .datatable-body-row.active.offline, ngx-datatable.ngx-datatable.material ::ng-deep .datatable-body-row.active.offline:hover, ngx-datatable.ngx-datatable.material ::ng-deep .datatable-body-row.active.offline:focus {
  background-color: var(--ion-color-light-shade) !important;
}
ngx-datatable.material ::ng-deep .datatable-header .datatable-header-cell.selection-cell, ngx-datatable.material ::ng-deep .datatable-body .datatable-body-row .datatable-body-cell.selection-cell {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
}
ngx-datatable.material ::ng-deep .datatable-body .datatable-body-row .datatable-body-cell.operation-cell {
  display: flex;
  align-items: center;
  padding-block: 0;
}
ngx-datatable.material ::ng-deep .datatable-body .datatable-body-row .datatable-body-cell.operation-cell .datatable-body-cell-label {
  width: 100%;
}
ngx-datatable ::ng-deep ion-checkbox.row-checkbox {
  pointer-events: none;
}
ngx-datatable ::ng-deep .datatable-grid {
  overflow-x: hidden;
}
ngx-datatable ::ng-deep .datatable-header-cell,
ngx-datatable ::ng-deep .datatable-body-cell {
  box-shadow: inset -1px -1px 0 var(--ion-color-light-shade);
}
ngx-datatable ::ng-deep .datatable-header-cell:last-child,
ngx-datatable ::ng-deep .datatable-body-cell:last-child {
  box-shadow: inset 0 -1px 0 var(--ion-color-light-shade);
}
ngx-datatable ::ng-deep datatable-row-wrapper:last-of-type .datatable-body-cell {
  box-shadow: inset -1px 0 0 var(--ion-color-light-shade);
}
ngx-datatable ::ng-deep datatable-row-wrapper:last-of-type .datatable-body-cell:last-child {
  box-shadow: none;
}

ion-header {
  border-bottom: 0;
}

ion-content.fixed-header-table {
  --overflow: hidden;
}
ion-content.fixed-header-table ngx-datatable {
  box-sizing: border-box;
  height: 100%;
}

ion-content + .pager,
ion-footer {
  margin-top: 13px;
}

:host::after {
  content: "";
  flex: none;
  order: 1;
  margin-top: auto;
}

ion-footer {
  order: 2;
}

.deselect {
  --color: var(--label-color, var(--ion-color-primary));
}

.action-picker {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  max-width: 100%;
  height: 36px;
  padding: 0 8px 0 12px;
  border: 1px solid var(--ui-field-border, rgba(15, 23, 42, 0.16));
  border-radius: var(--ui-field-radius, 10px);
  background: #fff;
  color: var(--ion-text-color, #0f172a);
  font-size: 0.875rem;
  cursor: pointer;
}
.action-picker:focus-visible {
  outline: none;
  border-color: var(--ion-color-primary);
}

.action-picker__icon {
  flex: none;
  font-size: 18px;
  color: var(--ion-color-primary);
}

.action-picker__label {
  min-width: 0;
  line-height: 1.5;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.action-picker__chevron {
  flex: none;
  width: 0.8125rem;
  color: var(--ion-color-step-500, var(--ion-text-color-step-500, gray));
  transition: transform 0.15s cubic-bezier(0.4, 0, 0.2, 1);
}

.action-picker--open .action-picker__chevron {
  transform: rotate(180deg);
}

ion-popover.action-popover::part(content) {
  border-radius: 10px;
}

.action-menu {
  padding-block: 4px;
  border-radius: 10px;
  border: 2px solid var(--ui-field-border, rgba(15, 23, 42, 0.16));
}
.action-menu ion-item {
  --min-height: 44px;
  --background-hover: var(--ion-color-primary);
  --background-hover-opacity: 0.06;
  font-size: 0.875rem;
}
.action-menu ion-icon[slot=start] {
  margin-inline-end: 12px;
  color: var(--ion-color-primary);
}

.action-menu__item--current {
  --background: var(--selected-background);
  font-weight: 600;
}`, "",{"version":3,"sources":["webpack://./src/components/shared-components/components/general-components/search-address/search-address.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,WAAA;EACA,oBAAA;AACF;;AAEA;EACE,OAAA;EACA,eAAA;EACA,kBAAA;EACA,8BAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,uDAAA;EACA,oCAAA;EACA,4BAAA;EACA,wCAAA;AACF;AACE;EACE,iBAAA;AACJ;;AAGA;EACE,8CAAA;AAAF;;AAGA;EACE,mDAAA;EACA,gBAAA;EACA,iDAAA;EACA,+CAAA;AAAF;;AAKA;EACE,uCAAA;EACA,yCAAA;AAFF;;AAKA;EACE,kBAAA;EACA,gBAAA;EACA,mBAAA;AAFF;;AAKA;EACE,cAAA;EACA,mBAAA;EACA,oBAAA;AAFF;;AAKA;EACE,cAAA;EACA,mBAAA;EACA,oBAAA;AAFF;;AAKA;EACE,wBAAA;EACA,mBAAA;EACA,qBAAA;EACA,mBAAA;EACA,sBAAA;AAFF;;AAMA;EACE,aAAA;EACA,eAAA;EACA,2BAAA;EACA,qBAAA;EACA,SAAA;EACA,mBAAA;AAHF;AAKE;EACE,YAAA;EACA,SAAA;AAHJ;AAOI;EACE,mBAAA;EACA,iCAAA;AALN;AAQI;EACE,6BAAA;AANN;AASI;EACE,+BAAA;AAPN;;AAYA;EACE,aAAA;EACA,UAAA;EACA,SAAA;AATF;;AAcA;EACE;IACE,gBAAA;IACA,yBAAA;EAXF;AACF;AAeA;EACE;IACE,kBAAA;EAbF;EAgBA;IACE,cAAA;EAdF;AACF;AAiBA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AAfF;AAkBE;EACE,UAAA;AAhBJ;;AAqBA;;;EAGE,eAAA;EACA,YAAA;AAlBF;;AAqBA;EACE,gBAAA;EAEA,6DAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,iBAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;AAnBF;;AAsBA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,iBAAA;EACA,eAAA;EACA,kBAAA;AAnBF;;AAsBA;EACE,cAAA;EACA,YAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;AAnBF;;AAsBA;EACE,gBAAA;EACA,6DAAA;EACA,eAAA;EACA,mBAAA;EACA,sBAAA;AAnBF;;AAsBA;EACE,kBAAA;EACA,gBAAA;EAEA,YAAA;EACA,WAAA;EAEA,2CAAA;EACA,mDAAA;AArBF;AAuBE;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EAEA,UAAA;EACA,YAAA;EAEA,sBAAA;EACA,iPAAA;EAOA,yEAAA;EAEA,4EAAA;AA9BJ;;AAkCA;EACE;IACE,mCAAA;EA/BF;EAkCA;IACE,kCAAA;EAhCF;AACF;AAmCA;EACE;IACE,eAAA;IAEA,WAAA;IACA,gEAAA;IACA,gBAAA;EAlCF;AACF;AAqCA;EACE,2FAAA;EAEA,gDAAA;AApCF;;AAwCA;EACE,kBAAA;EACA,oCAAA;EACA,oBAAA;EACA,oDAAA;AArCF;;AAyCA;EACE,kBAAA;EACA,uBAAA;EACA,4CAAA;AAtCF;;AA8CA;EACE,wBAAA;AA3CF;;AA+CA;EAEE,qGAAA;EACA,gBAAA;AA7CF;AAgDE;EACE,qDAAA;AA9CJ;AAuCA;EAUE,8CAAA;EACA,mBAAA;AA9CF;;AAiDA;;EAEE,aAAA;EACA,mBAAA;EACA,SAAA;EAEA,kBAAA;AA/CF;;AAkDA;EACE,gBAAA;EAEA,wCAAA;EACA,qDAAA;EACA,YAAA;EACA,eAAA;EACA,iBAAA;AAhDF;;AAmDA;EACE,gBAAA;EACA,eAAA;AAhDF;AAkDE;EACE,kDAAA;AAhDJ;AAmDE;EACE,2DAAA;AAjDJ;AAoDE;EACE,UAAA;EACA,oBAAA;AAlDJ;AAqDE;EACE,UAAA;EACA,cAAA;AAnDJ;;AAuDA;EACE,aAAA;EACA,OAAA;EACA,sBAAA;EACA,QAAA;EACA,YAAA;AApDF;;AAuDA;EACE,4BAAA;EACA,eAAA;EAEA,uBAAA;AArDF;;AAwDA;EACE,8BAAA;EACA,eAAA;EACA,uBAAA;AArDF;;AA0DA;EACE;;;GAAA;AApDF;;AA0DA;EACE,mBAAA;EACA,mBAAA;EACA,8CAAA;EACA,gBAAA;AAvDF;AAyDE;EACE,qDAAA;AAvDJ;AA4DE;EACE,sBAAA;EACA,wCAAA;EACA,YAAA;EACA,eAAA;EACA,iBAAA;EACA,2BAAA;EACA,iCAAA;EACA,8BAAA;AA1DJ;AA6DE;EACE,sBAAA;EACA,0BAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;AA3DJ;AA8DE;EACE,sBAAA;EACA,kCAAA;AA5DJ;AAkEI;EAGE,sEAAA;AAlEN;AAqEI;EAGE,yDAAA;AArEN;AA2EE;EAEE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,UAAA;AA1EJ;AA8EE;EACE,aAAA;EACA,mBAAA;EACA,gBAAA;AA5EJ;AA8EI;EACE,WAAA;AA5EN;AAiFE;EACE,oBAAA;AA/EJ;AAkFE;EACE,kBAAA;AAhFJ;AAoFI;;EAEE,0DAAA;AAlFN;AAqFI;;EAEE,uDAAA;AAnFN;AAsFI;EACE,uDAAA;AApFN;AAuFI;EACE,gBAAA;AArFN;;AA0FA;EACE,gBAAA;AAvFF;;AA4FA;EACE,kBAAA;AAzFF;AA2FE;EACE,sBAAA;EACA,YAAA;AAzFJ;;AA6FA;;EAEE,gBAAA;AA1FF;;AA6FA;EACE,WAAA;EACA,UAAA;EACA,QAAA;EACA,gBAAA;AA1FF;;AA6FA;EACE,QAAA;AA1FF;;AA6FA;EACE,qDAAA;AA1FF;;AA+FA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,YAAA;EACA,qBAAA;EACA,gEAAA;EACA,2CAAA;EACA,gBAAA;EACA,qCAAA;EACA,mBAAA;EACA,eAAA;AA5FF;AA8FE;EACE,aAAA;EACA,sCAAA;AA5FJ;;AAiGA;EACE,UAAA;EACA,eAAA;EACA,+BAAA;AA9FF;;AAiGA;EACE,YAAA;EACA,gBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AA9FF;;AAiGA;EACE,UAAA;EACA,gBAAA;EACA,sEAAA;EACA,wDAAA;AA9FF;;AAiGA;EACE,yBAAA;AA9FF;;AAiGA;EACE,mBAAA;AA9FF;;AAiGA;EACE,kBAAA;EACA,mBAAA;EACA,gEAAA;AA9FF;AAgGE;EACE,kBAAA;EACA,4CAAA;EACA,gCAAA;EACA,mBAAA;AA9FJ;AAiGE;EACE,uBAAA;EACA,+BAAA;AA/FJ;;AAmGA;EACE,wCAAA;EACA,gBAAA;AAhGF","sourcesContent":[".tab-container {\n  display: flex;\n  width: 100%;\n  padding-inline: 16px;\n}\n\n.tab-button {\n  flex: 1;\n  padding: 12px 0;\n  text-align: center;\n  color: var(--ion-color-medium);\n  font-size: 16px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: background-color 0.3s ease, color 0.3s ease;\n  border-bottom: 3px solid transparent;\n  border-radius: 16px 16px 0 0;\n  background-color: var(--ion-color-light);\n\n  &+ .tab-button {\n    margin-left: 32px;\n  }\n}\n\n.tab-button:hover {\n  background-color: var(--ion-color-light-shade);\n}\n\n.tab-button.active {\n  color: var(--label-color, var(--ion-color-primary));\n  font-weight: 600;\n  border-bottom: 3px solid var(--ion-color-primary);\n  background-color: var(--ion-color-primary-tint);\n}\n\n// Ionic adds 8px to the toolbars of the modals in iOS mode (core.css): the toolbars keep only the\n// side safe areas, so that the header and the footer line up with the table on every platform\n:host ion-toolbar {\n  padding-left: var(--ion-safe-area-left);\n  padding-right: var(--ion-safe-area-right);\n}\n\nion-header ion-toolbar {\n  --padding-start: 0;\n  --padding-end: 0;\n  --padding-bottom: 0;\n}\n\nion-header ion-title {\n  display: block;\n  margin-bottom: 10px;\n  padding-inline: 16px;\n}\n\n.subtitle {\n  display: block;\n  margin: -6px 0 10px;\n  padding-inline: 16px;\n}\n\nion-header ion-toolbar.filters-toolbar {\n  --ion-safe-area-top: 0px;\n  --padding-top: 10px;\n  --padding-start: 16px;\n  --padding-end: 16px;\n  --padding-bottom: 10px;\n}\n\n// Fields side by side, the filter button aligned with their boxes\n.filter-bar {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: flex-start;\n  align-items: flex-end;\n  gap: 16px;\n  padding-block: 10px;\n\n  ion-button {\n    height: 40px;\n    margin: 0;\n  }\n\n  ion-button[fill=\"outline\"] {\n    &::part(native) {\n      color: var(--color);\n      border-color: var(--border-color);\n    }\n\n    &.ion-activated::part(native) {\n      background: var(--background);\n    }\n\n    ion-icon {\n      color: var(--ion-color-primary);\n    }\n  }\n}\n\n.filter-actions {\n  display: flex;\n  flex: none;\n  gap: 16px;\n}\n\n// Compact layout (same width as the one-column table): the buttons on their own row under\n// the fields, on the right\n@media (max-width: 767.98px), (orientation: landscape) and (max-height: 500px) {\n  .filter-actions {\n    flex-basis: 100%;\n    justify-content: flex-end;\n  }\n}\n\n// Smartphone in landscape: lower title and tabs, the list needs the height\n@media (orientation: landscape) and (max-height: 500px) {\n  ion-header ion-title {\n    margin-bottom: 4px;\n  }\n\n  .tab-button {\n    padding: 6px 0;\n  }\n}\n\n.filter-field {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n\n  // The box under the label, as the outlined fields\n  ion-searchbar {\n    padding: 0;\n  }\n}\n\n// Side by side, sharing the row: the outlined fields would take its whole width\n.filter-field,\n.filter-bar > ion-input,\n.filter-bar > ion-select {\n  flex: 1 1 200px;\n  min-width: 0;\n}\n\n.filter-field__label {\n  overflow: hidden;\n\n  color: var(--ui-text-muted, var(--ion-color-medium, #6b7280));\n  font-size: 13px;\n  font-weight: 600;\n  letter-spacing: 0.02em;\n  line-height: 14px;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  margin-bottom: 2px;\n}\n\n.table-loader {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  height: 100%;\n  min-height: 200px;\n  padding: 0 24px;\n  text-align: center;\n}\n\n.table-loader__logo {\n  display: block;\n  width: 220px;\n  max-width: 100%;\n  height: 120px;\n  margin-bottom: 30px;\n  object-fit: contain;\n}\n\n.table-loader__message {\n  margin: 15px 0 0;\n  color: var(--ui-text-muted, var(--ion-color-medium, #6b7280));\n  font-size: 13px;\n  font-weight: normal;\n  letter-spacing: 0.02em;\n}\n\n.table-loader__progress {\n  position: relative;\n  overflow: hidden;\n\n  width: 148px;\n  height: 3px;\n\n  border-radius: var(--ui-radius-pill, 999px);\n  background: var(--ui-border, rgba(15, 23, 42, 0.1));\n\n  &::after {\n    position: absolute;\n    top: 0;\n    left: 0;\n    content: \"\";\n\n    width: 45%;\n    height: 100%;\n\n    border-radius: inherit;\n    background: linear-gradient(\n      90deg,\n      rgba(var(--ion-color-primary-rgb, 0, 84, 233), 0) 0%,\n      rgba(var(--ion-color-primary-rgb, 0, 84, 233), 0.85) 38%,\n      var(--ion-color-primary, #0054e9) 62%,\n      rgba(var(--ion-color-primary-rgb, 0, 84, 233), 0) 100%\n    );\n    box-shadow: 0 0 10px rgba(var(--ion-color-primary-rgb, 0, 84, 233), 0.45);\n\n    animation: table-loader-sweep 1450ms cubic-bezier(0.62, 0, 0.38, 1) infinite;\n  }\n}\n\n@keyframes table-loader-sweep {\n  from {\n    transform: translate3d(-110%, 0, 0);\n  }\n\n  to {\n    transform: translate3d(330%, 0, 0);\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .table-loader__progress::after {\n    animation: none;\n\n    width: 100%;\n    background: rgba(var(--ion-color-primary-rgb, 0, 84, 233), 0.45);\n    box-shadow: none;\n  }\n}\n\nnav.pager {\n  padding: 0 calc(var(--ion-safe-area-right) + 16px) 0\n    calc(var(--ion-safe-area-left) + 16px);\n  background: var(--ion-background-color, #ffffff);\n}\n\n// The toolbar already adds the side safe areas\nion-footer ion-text.selected-count {\n  padding-left: 16px;\n  color: var(--ion-color-medium-shade);\n  padding-right: 1.1em;\n  border-right: 1px solid var(--ion-color-light-shade);\n}\n\n// Row of count and deselect above the buttons, in the compact layout\nion-footer ion-toolbar.selection-toolbar {\n  --min-height: 44px;\n  --border-width: 0 0 1px;\n  --border-color: var(--ion-color-light-shade);\n}\n\n// Width of the scrollbar of ion-content (theme/scrollbar.scss), which takes room on mobile too\n$content-scrollbar-width: 10px;\n\n// The room of the scrollbar is kept even when the list does not scroll, and taken off the right\n// margin of the table: so the table lines up with the tabs and the filters\nion-content:has(> .compact-table)::part(scroll) {\n  scrollbar-gutter: stable;\n}\n\n// One-column table of the compact layout: same border, header and lines as the desktop one\n.compact-table {\n  // The popup is full screen in the compact layout: in landscape the notch is on one side\n  margin: 8px calc(var(--ion-safe-area-right) + 16px - #{$content-scrollbar-width}) 8px calc(var(--ion-safe-area-left) + 16px);\n  overflow: hidden;\n\n  // iOS ignores ::-webkit-scrollbar: the scrollbar is drawn over the content and takes no room\n  :host-context(.plt-ios) & {\n    margin-right: calc(var(--ion-safe-area-right) + 16px);\n  }\n\n  border: 1px solid var(--ion-color-light-shade);\n  border-radius: 10px;\n}\n\n.compact-table__header,\n.compact-table__row {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n\n  padding: 12px 16px;\n}\n\n.compact-table__header {\n  min-height: 50px;\n\n  background-color: var(--ion-color-light);\n  border-bottom: 1px solid var(--ion-color-light-shade);\n  color: black;\n  font-size: 14px;\n  font-weight: bold;\n}\n\n.compact-table__row {\n  min-height: 50px;\n  cursor: pointer;\n\n  & + & {\n    border-top: 1px solid var(--ion-color-light-shade);\n  }\n\n  &.selected {\n    background-color: var(--search-address-selected-background);\n  }\n\n  ion-checkbox.row-checkbox {\n    flex: none;\n    pointer-events: none;\n  }\n\n  ion-select {\n    flex: none;\n    max-width: 45%;\n  }\n}\n\n.compact-table__text {\n  display: flex;\n  flex: 1;\n  flex-direction: column;\n  gap: 2px;\n  min-width: 0;\n}\n\n.compact-table__title {\n  color: var(--ion-color-dark);\n  font-size: 14px;\n  // Addresses are long paths with no spaces: they wrap anywhere\n  overflow-wrap: anywhere;\n}\n\n.compact-table__subtitle {\n  color: var(--ion-color-medium);\n  font-size: 12px;\n  overflow-wrap: anywhere;\n}\n\n// Background of the selected rows: the theme one where defined (BIGStudio), otherwise a light\n// shade of the primary color (Digital Place has no such variable)\n:host {\n  --search-address-selected-background: var(\n    --selected-background,\n    rgba(var(--ion-color-primary-rgb), 0.12)\n  );\n}\n\nngx-datatable{\n  border-radius: 10px;\n  margin-inline: 16px;\n  border: 1px solid var(--ion-color-light-shade);\n  background: #fff;\n\n  &.material ::ng-deep .datatable-header {\n    border-bottom: 1px solid var(--ion-color-light-shade);\n  }\n\n  // Header and cells as the material theme in BIGStudio, which Digital Place does not load: its\n  // global header style (centred, wrapping text) is overridden, hence the !important\n  &.material ::ng-deep .datatable-header .datatable-header-cell {\n    padding: 0.9rem 1.2rem;\n    background-color: var(--ion-color-light);\n    color: black;\n    font-size: 14px;\n    font-weight: bold;\n    text-align: left !important;\n    vertical-align: bottom !important;\n    white-space: nowrap !important;\n  }\n\n  &.material ::ng-deep .datatable-body .datatable-body-row .datatable-body-cell {\n    padding: 0.9rem 1.2rem;\n    color: rgba(0, 0, 0, 0.87);\n    font-size: 14px;\n    font-weight: 400;\n    text-align: left;\n    vertical-align: top;\n  }\n\n  &.material ::ng-deep .datatable-body-row:not(.active):hover {\n    background-color: #eee;\n    transition: background 0.3s linear;\n  }\n\n  // Selected rows, grey when offline. Stronger than the Digital Place global rule, whose color\n  // is not defined for its theme\n  &.ngx-datatable.material ::ng-deep .datatable-body-row.active {\n    &.online,\n    &.online:hover,\n    &.online:focus {\n      background-color: var(--search-address-selected-background) !important;\n    }\n\n    &.offline,\n    &.offline:hover,\n    &.offline:focus {\n      background-color: var(--ion-color-light-shade) !important;\n    }\n  }\n\n  // Checkbox column of the multi-selection: the material padding would leave no room for\n  // the checkbox in 56px, so it is dropped and the checkbox is centred\n  &.material ::ng-deep .datatable-header .datatable-header-cell.selection-cell,\n  &.material ::ng-deep .datatable-body .datatable-body-row .datatable-body-cell.selection-cell {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: 0;\n  }\n\n  // Scenario operation select: the material vertical padding would leave it no room\n  &.material ::ng-deep .datatable-body .datatable-body-row .datatable-body-cell.operation-cell {\n    display: flex;\n    align-items: center;\n    padding-block: 0;\n\n    .datatable-body-cell-label {\n      width: 100%;\n    }\n  }\n\n  // The row checkbox only shows the state: the click goes to the row, which toggles it\n  ::ng-deep ion-checkbox.row-checkbox {\n    pointer-events: none;\n  }\n\n  ::ng-deep .datatable-grid {\n    overflow-x: hidden;\n  }\n\n  ::ng-deep {\n    .datatable-header-cell,\n    .datatable-body-cell {\n      box-shadow: inset -1px -1px 0 var(--ion-color-light-shade);\n    }\n\n    .datatable-header-cell:last-child,\n    .datatable-body-cell:last-child {\n      box-shadow: inset 0 -1px 0 var(--ion-color-light-shade);\n    }\n\n    datatable-row-wrapper:last-of-type .datatable-body-cell {\n      box-shadow: inset -1px 0 0 var(--ion-color-light-shade);\n    }\n\n    datatable-row-wrapper:last-of-type .datatable-body-cell:last-child {\n      box-shadow: none;\n    }\n  }\n}\n\nion-header{\n  border-bottom: 0;\n}\n\n// The table is the one scrolling, under its fixed header. It fills the whole content, border\n// included: the content is as tall as the table, or shorter when there is no room for it\nion-content.fixed-header-table {\n  --overflow: hidden;\n\n  ngx-datatable {\n    box-sizing: border-box;\n    height: 100%;\n  }\n}\n\nion-content + .pager,\nion-footer {\n  margin-top: 13px;\n}\n\n:host::after {\n  content: \"\";\n  flex: none;\n  order: 1;\n  margin-top: auto;\n}\n\nion-footer {\n  order: 2;\n}\n\n.deselect{\n  --color: var(--label-color, var(--ion-color-primary));\n}\n\n// Command type of a picked scenario: a button showing the action chosen, with its icon, that\n// opens the actions menu. 36px tall, so that it fits in the 50px rows\n.action-picker {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  max-width: 100%;\n  height: 36px;\n  padding: 0 8px 0 12px;\n  border: 1px solid var(--ui-field-border, rgba(15, 23, 42, 0.16));\n  border-radius:  var(--ui-field-radius, 10px);\n  background: #fff;\n  color: var(--ion-text-color, #0f172a);\n  font-size: 0.875rem;\n  cursor: pointer;\n\n  &:focus-visible {\n    outline: none;\n    border-color: var(--ion-color-primary);\n  }\n}\n\n// The primary color, unless the option has its own (inline style from its color variable)\n.action-picker__icon {\n  flex: none;\n  font-size: 18px;\n  color: var(--ion-color-primary);\n}\n\n.action-picker__label {\n  min-width: 0;\n  line-height: 1.5;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.action-picker__chevron {\n  flex: none;\n  width: 0.8125rem;\n  color: var(--ion-color-step-500, var(--ion-text-color-step-500, gray));\n  transition: transform 0.15s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n.action-picker--open .action-picker__chevron {\n  transform: rotate(180deg);\n}\n\nion-popover.action-popover::part(content) {\n  border-radius: 10px;\n}\n\n.action-menu {\n  padding-block: 4px;\n  border-radius: 10px;\n  border: 2px solid var(--ui-field-border, rgba(15, 23, 42, 0.16));\n\n  ion-item {\n    --min-height: 44px;\n    --background-hover: var(--ion-color-primary);\n    --background-hover-opacity: 0.06;\n    font-size: 0.875rem;\n  }\n\n  ion-icon[slot=\"start\"] {\n    margin-inline-end: 12px;\n    color: var(--ion-color-primary);\n  }\n}\n\n.action-menu__item--current {\n  --background: var(--selected-background);\n  font-weight: 600;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
